export default __webpack_public_path__ + "static/media/go_back_icon.50997b0e.svg";